/**
 * Governed citation PDF highlight eligibility (presentation-only).
 */

export function shouldOfferGovernedCitationPdfHighlight(input: {
  contentType: string;
  pageNumber?: number | null;
  citedPassage?: string | null;
}): boolean {
  return (
    input.contentType === "application/pdf" &&
    typeof input.pageNumber === "number" &&
    Number.isInteger(input.pageNumber) &&
    input.pageNumber > 0 &&
    typeof input.citedPassage === "string" &&
    input.citedPassage.trim().length > 0
  );
}
